import { useCallback, useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import Timeline from './src';

import { Button, Switch, Tooltip } from 'src/components';
import { useReduxDispatch, useReduxSelector } from 'src/redux/store';
import { getTimeline } from 'src/redux/timeline/actions';
import { toggleTrackOpen } from 'src/redux/timeline/timelineSlice';

import {
  END_OF_YEAR,
  END_OF_YEAR_FORMATTED,
  START_OF_YEAR,
  START_OF_YEAR_FORMATTED,
  TIMEBAR,
} from './src/utils/builder';

const TimeLine = () => {
  const dispatch = useReduxDispatch();
  const { data, loadingStatus } = useReduxSelector((store) => store.timeline);
  const fetchTimeline = useCallback(
    (params?: { byHours?: boolean; byProjects?: boolean }) => {
      dispatch(
        getTimeline({
          start_date: START_OF_YEAR_FORMATTED,
          end_date: END_OF_YEAR_FORMATTED,
          ...params,
        })
      );
    },
    [dispatch]
  );

  useEffect(() => {
    fetchTimeline();
  }, [fetchTimeline]);

  const [selectedView, setSelectedView] = useState<'teamView' | 'projectView'>(
    'teamView'
  );
  const [teamViewType, setTeamViewType] = useState<'projects' | 'hours'>(
    'projects'
  );

  const handleToggleTrackOpen = (track: any) => {
    dispatch(toggleTrackOpen({ trackId: track?.id ?? '' }));
  };
  const handleToggleSwitch = () => {
    if (teamViewType === 'projects') {
      setTeamViewType('hours');
      fetchTimeline({ byHours: true });
      return;
    }
    setTeamViewType('projects');
    fetchTimeline();
  };
  console.log({ data });

  return (
    <div>
      <div className="flex flex-col md:flex-row items-center justify-between mr-4 md:mr-10 ">
        <div className="my-8 p-1 bg-cream rounded-lg inline-flex border-lightCream border">
          <Button
            variant={selectedView === 'teamView' ? 'normal' : 'text'}
            size="sm"
            label="Team View"
            className=" w-40 h-12 "
            type="button"
            roundness="rounded-lg"
            onClick={() => {
              setSelectedView('teamView');
              setTeamViewType('projects');
              fetchTimeline();
            }}
            loaderClassName="h-5"
            labelClassName={`font-SFProDisplay_Semibold text-base ${
              selectedView !== 'teamView' && 'text-muted'
            }`}
            disabled={loadingStatus === 'PENDING'}
          />
          <Button
            variant={selectedView === 'projectView' ? 'normal' : 'text'}
            size="sm"
            label="Project View"
            className=" w-40 h-12"
            type="button"
            roundness="rounded-lg"
            onClick={() => {
              setSelectedView('projectView');
              fetchTimeline({ byProjects: true });
            }}
            loaderClassName="h-5"
            labelClassName={`font-SFProDisplay_Semibold text-base ${
              selectedView !== 'projectView' && 'text-muted'
            }`}
            disabled={loadingStatus === 'PENDING'}
          />
        </div>
        {selectedView === 'teamView' && (
          <div>
            <div className="flex md:items-center space-x-4 mb-8 md:mb-0">
              <p
                className={`font-SFProDisplay_Semibold text-sm ${
                  teamViewType === 'hours' && 'text-muted'
                }`}
              >
                Number of Projects
              </p>
              <Switch
                onChange={handleToggleSwitch}
                disabled={loadingStatus === 'PENDING'}
              />
              <p
                className={`font-SFProDisplay_Semibold text-sm ${
                  teamViewType === 'projects' && 'text-muted'
                }`}
              >
                Total Hours
              </p>
            </div>
          </div>
        )}
      </div>

      <div>
        {loadingStatus === 'PENDING' ? (
          <div>
            <Skeleton containerClassName="flex-1" height={80} />
            <Skeleton containerClassName="flex-1" height={25} count={5} />
          </div>
        ) : (
          <Timeline
            scale={{
              start: START_OF_YEAR,
              end: END_OF_YEAR,
              zoom: 0,
              zoomMin: 0,
              zoomMax: 10,
            }}
            timebar={TIMEBAR}
            tracks={data ?? []}
            now={new Date()}
            toggleTrackOpen={handleToggleTrackOpen}
            clickElement={(d: any) => console.log({ d })}
            enableSticky
            scrollToNow
            zoom={0}
          />
        )}
      </div>
    </div>
  );
};

export default TimeLine;
